// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import RideMap from './components/RideMap';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import HomeSlot from './components/HomeSlot';
import HomeSlot2 from './components/HomeSlot2';
import HomeWork from './components/HomeWork';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import AboutUsSlot from './components/AboutUsSlot';
import AboutVid from './components/AboutVid';
import ContactUs from './components/ContactUs';
import FAQ from './components/FAQ';
import Blog from './components/Blog';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import RequireAdmin from './components/admin/RequireAdmin';
import RoutePrice from './components/admin/RoutePrice';
import Sidebar from './components/admin/Sidebar';

function AdminLayout({ children }) {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div style={{ flex: 1, padding: '20px' }}>{children}</div>
    </div>
  );
}

function AppWrapper() {
  const location = useLocation();
  const path = location.pathname;

  // Hide Header & Footer for these paths
  const hideHeaderFooter =
    path.startsWith('/ride/') ||
    path === '/admin' ||
    path.startsWith('/admin/dashboard') ||
    path.startsWith('/admin/routeprice');

  return (
    <>
      {!hideHeaderFooter && <Header />}

      <Routes>
        {/* Ride Tracking */}
        <Route path="/ride/:rideId" element={<RideMap />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <RequireAdmin>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/routeprice"
          element={
            <RequireAdmin>
              <AdminLayout>
                <RoutePrice />
              </AdminLayout>
            </RequireAdmin>
          }
        />

        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <HomeSlot />
              <HomeSlot2 />
              <HomeWork />
              <Footer />
            </>
          }
        />

        {/* About Us Page */}
        <Route
          path="/aboutus"
          element={
            <>
              <AboutUs />
              <AboutUsSlot />
              <AboutVid />
              <Footer />
            </>
          }
        />

        {/* Contact Us Page */}
        <Route
          path="/contactus"
          element={
            <>
              <ContactUs />
              <Footer />
            </>
          }
        />

        {/* FAQ Page */}
        <Route
          path="/faq"
          element={
            <>
              <FAQ />
              <Footer />
            </>
          }
        />

        {/* Blog Page */}
        <Route
          path="/blog"
          element={
            <>
              <Blog />
              <Footer />
            </>
          }
        />

        {/* Privacy Policy Page */}
        <Route
          path="/privacy"
          element={
            <>
              <PrivacyPolicy />
              <Footer />
            </>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

export default App;
